import { Phone, Mail } from 'lucide-react';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-navy py-16">
        <div className="container mx-auto px-4">
          <h1 className="font-oswald text-4xl md:text-5xl font-bold text-white text-center">
            Terms & Conditions
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              <strong>Effective Date:</strong> April 27, 2026
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">1. Consent</h2>
            <p className="text-gray-700 mb-6">
              You agree to receive communications via phone, email, and SMS.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">2. Message Types</h2>
            <p className="text-gray-700 mb-6">
              Reminders, updates, support, and marketing.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">3. Frequency</h2>
            <p className="text-gray-700 mb-6">
              Varies based on interaction.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">4. Rates</h2>
            <p className="text-gray-700 mb-6">
              Message and data rates may apply.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">5. Opt-Out</h2>
            <p className="text-gray-700 mb-6">
              Reply STOP to unsubscribe or HELP for support.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">6. Contact</h2>
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <p className="font-bold text-navy mb-2">Bruce Nelson Plumbing & Heating</p>
              <p className="text-gray-700 flex items-center gap-2 mb-1">
                <Phone className="w-4 h-4" /> 651-738-9354
              </p>
              <p className="text-gray-700 flex items-center gap-2">
                <Mail className="w-4 h-4" /> info@brucenelsonph.com
              </p>
            </div>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">7. Use</h2>
            <p className="text-gray-700 mb-6">
              Provide accurate info and lawful use.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">8. Liability</h2>
            <p className="text-gray-700 mb-6">
              Not liable for indirect damages.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">9. Updates</h2>
            <p className="text-gray-700 mb-6">
              Terms may change.
            </p>

            <h2 className="font-oswald text-2xl font-bold text-navy mt-8 mb-4">10. Acceptance</h2>
            <p className="text-gray-700 mb-6">
              Use of services means acceptance.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
